import React from "react"
import {NavLink, useNavigate } from "react-router-dom"
import "./Footer.css"

export default function Footer() {

    const navigate = useNavigate()

    return <footer>        
        <button onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}>
            <div><i className="fa-solid fa-angle-left"/></div>
        </button>
        <div className="divider"/>
        <NavLink to="/"><div>Glavna</div></NavLink>
        <div className="divider"/>
        <NavLink to="/report"><div>Izveštaj</div></NavLink>
        <div className="divider"/>
        <NavLink to="/shift"><div>Smena</div></NavLink>
        <div className="divider"/>
    </footer>
}